// lodash
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import checkStringContains from '../string/checkStringContains';
import deliveryConstants from '../../constants/deliveryConstants';
import appConstants from '../../constants/appConstants';

export function isGreenVanFleet(deliveryType) {
  return deliveryType === deliveryConstants.GREEN_VAN_FLEET;
}

export function isGreenVanFleetExCatchment(deliveryType, fulfilment) {
  return isGreenVanFleet(deliveryType) &&
    get(fulfilment, 'bookingType', '') === deliveryConstants.NIGHTFREIGHT;
}

export function isGreenVanFleetUnavailable(deliveryType, fulfilment) {
  return !!(isGreenVanFleet(deliveryType) && !fulfilment.deliveryInfo?.date);
}

export function isTradeplaceDelivery(deliveryType) {
  return deliveryType === deliveryConstants.TRADEPLACE;
}

export function isMadeToMeasureDelivery(deliveryType) {
  return deliveryType === deliveryConstants.MADE_TO_MEASURE;
}

export function isOneManPremiumDelivery(delivery) {
  return delivery.type === deliveryConstants.ONE_MAN && !!get(delivery.fulfilment, 'deliveryInfo.date');
}

export function isOneManMorningDelivery(delivery) {
  return isOneManPremiumDelivery(delivery) &&
    checkStringContains(get(delivery.fulfilment, 'description').toLowerCase(), ['next', 'named', 'morning']);
}

export function isOneManEveningDelivery(delivery) {
  return isOneManPremiumDelivery(delivery) &&
    checkStringContains(get(delivery.fulfilment, 'description').toLowerCase(), ['evening', 'm25']);
}

export function isOneManDayDelivery(delivery) {
  return isOneManPremiumDelivery(delivery) &&
    checkStringContains(get(delivery.fulfilment, 'description').toLowerCase(), ['next', 'named', 'day']);
}

export function isClickCollect(delivery) {
  return !!get(delivery, 'fulfilment.collectionInfo');
}

export function getDeliveryInstructionDropdownOptions(
  selectedDeliveryMethodId,
  deliveryMethods,
  deliveryAccessibilityInstructionsEnabled,
) {
  const deliveryInstructions = deliveryAccessibilityInstructionsEnabled ?
    appConstants.DELIVERY_ACCESSIBILITY_INSTRUCTIONS : appConstants.DELIVERY_INSTRUCTIONS;

  if (!isEmpty(deliveryMethods) && selectedDeliveryMethodId) {
    const filteredDeliveryInstructions = deliveryInstructions;

    const availableOptions = filteredDeliveryInstructions
      .map(item => ({
        ...item,
        value: item.label,
        label: item.label,
        ...(deliveryAccessibilityInstructionsEnabled ? { prefix: `${item.label}:` } : {}),
      }));

    availableOptions.unshift({
      label: 'Select an option:',
      value: '',
    });

    return availableOptions;
  }

  return [];
}

export function getDeliveryInstructionsText(deliveryInstructions, deliveryAccessibilityInstructionsEnabled) {
  if (deliveryAccessibilityInstructionsEnabled) {
    return deliveryInstructions; // return the text with the prefix
  }

  if (!deliveryInstructions) {
    return '';
  }

  if (!deliveryInstructions.includes(':')) {
    return deliveryInstructions;
  }

  const userProvidedText = deliveryInstructions.split(':').slice(1).join(':');

  if (userProvidedText.trim().length <= 0) {
    return '';
  }

  return userProvidedText.trim();

}
